/**
 * Module containing constants for different cookies used on the project.
 *
 */

/**
 * Cookies used by Dynamic Yield
 */
const DYNAMIC_YIELD_COOKIES = {
  SERVER: '_dyid_server',
  SESSION: '_dyjsession',
};

/**
 * Cookies and URL params used by Iterable
 */
const CUSTOMER_ITERABLE = {
  ITERABLE_CAMPAIGN_ID_COOKIE: 'iterable-campaign-id',
  ITERABLE_EMAIL_ALLBIRDS_ID_QUERY_PARAM: 'allbirds_id',
  ITERABLE_EMAIL_CAMPAIGN_ID_QUERY_PARAM: 'Iterable_campaign',
  ITERABLE_EMAIL_COOKIE: 'iterableEndUserId',
  ITERABLE_EMAIL_TEMPLATE_ID_QUERY_PARAM: 'Iterable_template',
  ITERABLE_EMAIL_USER_ID_QUERY_PARAM: 'id',
  ITERABLE_TEMPLATE_ID_COOKIE: 'iterable-template-id',
};

/**
 * Cookies used for tracking customers
 */
const CUSTOMER_TRACKING_COOKIES = {
  ALLBIRDS_BLISSPOINT_EMAIL: 'allbirds-blisspoint-email',
  ALLBIRDS_ENCRYPTED_EMAIL: 'allbirds-encrypted-email',
  ALLBIRDS_ID: 'allbirds_id',
  DYNAMIC_YIELD: DYNAMIC_YIELD_COOKIES.SESSION,
  DYNAMIC_YIELD_SERVER: DYNAMIC_YIELD_COOKIES.SERVER,
  LAST_ACTION_TIMESTAMP: 'allbirds-last-action-',
  PREFERRED_STORE: 'allbirds-preferred-store',
  SESSION_REPLAY_SESSION_ID: 'allbirds-session-replay-session-id',
  SHOPIFY_SESSION_ID: '_shopify_y',
  SHOPIFY_SESSION_S_ID: '_shopify_s',
  USER_ID: 'user_id',
  USER_STATE: 'allbirds-user-state',
};

/**
 * Possible states for a customer user
 */
const CUSTOMER_USER_STATES_COOKIES = {
  ANONYMOUS: 'anonymous',
  IDENTIFIED: 'identified',
  LOGGED_IN: 'loggedIn',
};

/**
 * Expiration constants in days
 */
const EXPIRATION_COOKIES = {
  ONE_DAY: 1,
  ONE_YEAR: 365.25,
};

const GEOFENCING_COOKIES = {
  GEOFENCING_MODAL_CLOSED: 'allbirds-geofencing-modal-closed',
  USER_INFERRED_COUNTRY: 'allbirds-inferred-user-country',
  USER_SELECTED_SHOP: 'allbirds-selected-user-shop',
};

export {
  CUSTOMER_ITERABLE,
  CUSTOMER_TRACKING_COOKIES,
  CUSTOMER_USER_STATES_COOKIES,
  DYNAMIC_YIELD_COOKIES,
  EXPIRATION_COOKIES,
  GEOFENCING_COOKIES,
};
